import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useRef, useState, useEffect } from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Box from '../Box/index.esm.js';

function useHasImageLoaded(props) {
  var src = props.src,
      onLoad = props.onLoad,
      onError = props.onError;
  var ref = useRef(true);

  var _useState = useState(false),
      hasLoaded = _useState[0],
      setHasLoaded = _useState[1];

  useEffect(function () {
    if (!src) {
      return;
    }

    var image = new window.Image();

    image.onload = function (event) {
      if (ref.current) {
        setHasLoaded(true);

        if (onLoad) {
          // @ts-ignore
          onLoad(event);
        }
      }
    };

    image.onerror = function (event) {
      if (ref.current) {
        setHasLoaded(false);

        if (onError) {
          // @ts-ignore
          onError(event);
        }
      }
    };

    image.src = src;
  }, [src, onLoad, onError]);
  useEffect(function () {
    return function () {
      ref.current = false;
    };
  }, []);
  return hasLoaded;
}
var NativeImage = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var htmlWidth = props.htmlWidth,
      htmlHeight = props.htmlHeight,
      _props$alt = props.alt,
      alt = _props$alt === void 0 ? '' : _props$alt,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? 'lazy' : _props$loading,
      rest = _objectWithoutPropertiesLoose(props, ["htmlWidth", "htmlHeight", "alt", "loading"]);

  return React__default.createElement("img", _extends({
    ref: ref,
    width: htmlWidth,
    height: htmlHeight,
    alt: alt,
    loading: loading
  }, rest));
});
var Image = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var src = props.src,
      onError = props.onError,
      onLoad = props.onLoad,
      htmlWidth = props.htmlWidth,
      htmlHeight = props.htmlHeight,
      rest = _objectWithoutPropertiesLoose(props, ["src", "onError", "onLoad", "htmlWidth", "htmlHeight"]);

  var imageProps = {
    src: src,
    onLoad: onLoad,
    onError: onError,
    htmlWidth: htmlWidth,
    htmlHeight: htmlHeight
  };
  var hasLoaded = useHasImageLoaded(imageProps);
  return React__default.createElement(Box, _extends({
    as: NativeImage,
    ref: ref,
    transitionDuration: "duration-200",
    transitionTimingFunction: "ease-in",
    transitionProperty: "transition-opacity",
    opacity: hasLoaded ? 'opacity-100' : 'opacity-0'
  }, imageProps, rest));
});

if (__DEV__) {
  Image.displayName = 'Image';
}

export default Image;
export { useHasImageLoaded };
//# sourceMappingURL=index.esm.js.map
